<template>
  <div></div>
</template>

<script>
import loginService from "../services/loginService";

export default {
  data() {
    return {
      context: "oauth2 context",
      code: this.$route.query.code,
      type: this.$route.params.vertical,
    };
  },
  mounted() {
    console.log(this.$route);
    console.log("mounted oauth2");
    console.log(this.code);

    let vertical = this.$route.params.vertical;

    if (vertical == "/") {
      vertical = "geodir";
    }
    let redirectRoute = process.env.VUE_APP_URL_REDIRECT_URL + "/" + vertical;

    console.log("ruta redireccion");
    console.log(redirectRoute);

    if (this.code) {
      const authToken = {};
      var app = this;
      var loginDetails = {};

      loginService
        .token(this.code, redirectRoute)
        .then(function (res) {
          if (res.status === "success") {
            authToken.data = res.data;
            app.$store.state.isLoggedIn = true;

            console.log("***********************");
            console.log("OBTENER TOKEN");

            console.log(authToken);

            window.localStorage.setItem(
              "geodir_Token",
              JSON.stringify(authToken)
            );
            let loginRedirect = JSON.parse(
              localStorage.getItem("LOGINREDIRECT")
            );
            app.$router.push(loginRedirect);
          } else {
            app.$store.state.isLoggedIn = false;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  },

  methods: {},
};
</script>
<style scoped>
.outer {
  display: table;
  position: absolute;
  height: 100%;
  width: 100%;
}

.middle {
  display: table-cell;
  vertical-align: middle;
}

.inner {
  margin-left: auto;
  margin-right: auto;
}
.centering {
  width: 400px;
  height: auto;
  background: #fff;
  padding: 30px;
  margin: 10px auto;
}
</style>
